import Button from '@app-studio-web/ui/components/Button'
import InfoBox from '@app-studio-web/ui/components/InfoBox'
import Layout from '@app-studio-web/ui/components/Layout'
import Logo from '@components/Logo'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'
import { getAllAnswers } from '../../utils/onboardingStorage'

export default function OnboardingCompletionPage() {
  const { t } = useTranslation()

  const handleSubmit = () => {
    // If this is the last page of onboarding, send all answers to React Native
    if (window.ReactNativeWebView) {
      const allAnswers = getAllAnswers()
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'ONBOARDING_COMPLETE',
          onboardingAnswers: allAnswers,
        }),
      )
    }
  }

  return (
    <Layout>
      <div
        className="flex h-full w-full flex-col text-center"
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div className="pt-[60px] sm:pt-[178px]">
          {<Logo className="h-[239px] w-[239px]" />}
        </div>

        <InfoBox>
          <p className="text-center text-base" style={{ fontSize: '20px' }}>
            {t('pages.onboarding.onboardingCompletion.description')}
          </p>
        </InfoBox>

        <Form
          className="shrink-0"
          method="post"
          onSubmit={handleSubmit}
          style={{ width: '100%' }}
        >
          <Button
            title={t('shared.continue')}
            type="submit"
            dataTestId="button-continue"
            className="w-full"
          />
        </Form>
      </div>
    </Layout>
  )
}
